export default "__VITE_ASSET__CDXa3RP1__"